import React from 'react';
import {addFunc, avgFunc, fixIt} from "../../../../../components/functions/Mathematik";
import {monthName} from "../../../../../components/functions/Month";

function Talab({selectedCrops, locations}) {
    const mdata1 = localStorage.getItem('sfr-fao-mdata')
    const mdata = mdata1?JSON.parse(mdata1):[]
    const dayOfYear = (date) => {
        if(!isNaN(new Date(date))) {
            let today = new Date(date)
            return Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24)
        }
    }
    let e3 = (Math.PI/180)*locations.lat
    let x3 = 101.3 * Math.pow(((293 - 0.0065 * locations.alt) / 293),5.26)
    const y3 = x3 * 0.665 / 1000
    const head1 = () => {
        let obj = []
        if(Object.keys(selectedCrops).length){
            Object.values(selectedCrops).map((crop,index)=>{
                obj.push(
                    <td className="outlined" key={index+'name'} colSpan={2}>{crop.name}</td>
                )
            })
        }
        return obj
    }
    const head2 = () => {
        let obj = []
        if(Object.keys(selectedCrops).length){
            Object.values(selectedCrops).map((crop,index)=>{
                obj.push(
                    <td className="outlined" key={index+'2b'}>mm</td>
                )
                obj.push(
                    <td className="outlined" key={index+'2r'}>ming.m<sup>3</sup></td>
                )
            })
        }
        return obj
    }
    const checkDate = (date) => {
        if(!isNaN(new Date(date))){
            return new Date(date).toISOString().slice(0,10)
        }
    }
    const getMonth = (date) => {
        if(!isNaN(new Date(date))){
            return new Date(date).getMonth()
        }
    }
    const getDecade = (date) => {
        if(!isNaN(new Date(date))){
            let d = new Date(date).getDate() / 10.5
            return Math.floor(d)
        }
    }
    const getUnixDate = (date,adddays = 0) => {
        if(!isNaN(new Date(date))){
            return new Date(date).getTime() + adddays * 86400000
        }
    }
    const evp = () => {
        let evop = {}
        if(mdata.length) {
            mdata.map((d, i) => {
                if (i > 1) {
                    const mon = getMonth(d.sana)
                    const dek = getDecade(d.sana)
                    const yeardays = new Date(d.sana).getFullYear()%4==0?366:365
                    let b3 = avgFunc([d.max_xavo,d.min_xavo])
                    let d3 = d.shamol_tezlik*86.4
                    let f3 = dayOfYear(d.sana)
                    let g3 = (0.409*Math.sin(2*Math.PI*dayOfYear(d.sana)/yeardays-1.39))
                    let h3 = Math.acos(-Math.tan(e3)*Math.tan(g3))
                    let i3 = 1 + 0.033 * Math.cos((2 * Math.PI * yeardays)*f3)
                    let j3 = ((24 * 60 / Math.PI * 0.082 * i3 * (h3 * Math.sin(e3) * Math.sin(g3) + Math.cos(e3) * Math.cos(g3) * Math.sin(h3))))
                    let k3 = (24 / Math.PI) * h3
                    let l3 = j3 * (0.25 + 0.5 * d.kun_soat / k3)
                    let m3 = (0.75 + ((2 * Math.pow(10,-5)) * locations.alt)) * j3
                    let n3 = 0.77 * l3
                    let o3 = 0.6108 * Math.exp((17.27 * d.max_xavo)/(d.max_xavo + 237.3))
                    let p3 = 0.6108 * Math.exp((17.27 * d.min_xavo)/(d.min_xavo + 237.3))
                    let q3 = avgFunc([o3,p3])
                    let r3 = 0.5 * (o3 * d.min_nam + p3 * d.max_nam) / 100
                    let s3 = 4.903 * Math.pow(10,-9) * Math.pow((d.max_xavo + 273.16),4)
                    let t3 = 4.903 * Math.pow(10,-9) * Math.pow((d.min_xavo + 273.16),4)
                    let u3 = ((s3 + t3) / 2) * (0.34 - 0.14 * Math.pow(r3,0.5)) * (1.35 * (l3 / m3) - 0.35)
                    let v3 = n3 - u3
                    let w3 = 0
                    let z3 = 4098 * 0.6108 * Math.exp(17.27 * b3 / (b3 + 237.3)) / Math.pow((b3 + 237.3),2)

                    let b5 = (0.408 * z3 * (v3 - w3) + y3 * (900 / (b3 + 273)) * d3 * (q3 - r3)) / (z3 + y3 * (1 + 0.34 * d3))
                    let c5 = d.yogin_mm > 5 ? d.yogin_mm - 5 : 0
                    if(Object.keys(selectedCrops).length){
                        Object.values(selectedCrops).map(crop=>{
                            if(!evop['m'+mon]){
                                evop['m'+mon] = {['d'+dek]:{['c'+crop.id]:0}}
                            }
                            if(!evop['m'+mon]['d'+dek]){
                                evop['m'+mon]['d'+dek] = {['c'+crop.id]:0}
                            }
                            let d5 = 0
                            const cd = d.sana
                            const bd = getUnixDate(crop.bosh_date)
                            const rd = addFunc(bd,(parseInt(crop.bosh_d) * 86400000))
                            if(cd >= bd && rd > cd){
                                d5 = crop.bosh_k
                            }
                            let e5 = b5 * d5
                            let f5 = 0
                            const od = addFunc(rd,(parseInt(crop.riv_d) * 86400000))
                            if(cd >= rd && od > cd){
                                f5 = crop.riv_k
                            }
                            let g5 = b5 * f5
                            let h5 = 0
                            const oxd = addFunc(od,(parseInt(crop.orta_d) * 86400000))
                            if(cd >= od && oxd > cd){
                                h5 = crop.orta_k
                            }
                            let i5 = b5 * h5
                            let j5 = 0
                            const jd = addFunc(oxd,(parseInt(crop.oxir_d) * 86400000))
                            if(cd >= oxd && jd > cd){
                                j5 = crop.oxir_k
                            }
                            let k5 = b5 * j5
                            let l5 = 0
                            if((e5 + g5 + i5 + k5) != 0){
                                l5 = e5 + g5 + i5 + k5 - c5
                            }
                            evop['m'+mon]['d'+dek]['c'+crop.id] = addFunc(evop['m'+mon]['d'+dek]['c'+crop.id],l5)
                        })
                    }
                }
            })
        }
        return evop
    }
    const yx = (month,dekada,data) => {
        let tr = []

        if(Object.keys(selectedCrops).length){
            Object.values(selectedCrops).map((crop,cind)=>{
                let a4 = data['c'+crop.id]
                tr.push(
                    <td key={month+"m"+dekada+"d"+cind+"mm"}>{a4?fixIt(a4):''}</td>
                )
                let b4 = a4 * crop.maydon / crop.fik / 100
                tr.push(
                    <td key={month+"m"+dekada+"d"+cind+"ming"}>{b4?fixIt(b4):''}</td>
                )
            })
        }
        return tr
    }
    const xisobot = () => {
        const evps = evp()
        const months = ["Yanvar", "Fevral","Mart","Aprel","May","Iyun","Iyul","Avgust","Sentyabr","Oktyabr","Noyabr","Dekabr"]
        let obj = [];
        [0,1,2,3,4,5,6,7,8,9,10,11].map(i=>{
            let a4 = months[i]
            obj.push(
                <tbody key={i}>
                <tr>
                    <td className="text-nowrap" rowSpan={3}>{a4}</td>
                    <td>1</td>
                    {
                        yx(i,0,evps['m'+i]?evps['m'+i].d0:0)
                    }
                </tr>
                <tr>
                    <td>2</td>
                    {
                        yx(i,1,evps['m'+i]?evps['m'+i].d1:0)
                    }
                </tr>
                <tr>
                    <td>3</td>
                    {
                        yx(i,2,evps['m'+i]?evps['m'+i].d2:0)
                    }
                </tr>
                </tbody>
            )
        })
        return obj
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="flextable mt-3" style={{height:"85vh"}}>
                    <table className="table mx-auto table-bordered tableFixHead fao-table meteoxisob" style={{width:"unset"}}>
                        <thead style={{background:"#fff"}}>
                        <tr>
                            <td rowSpan="2" className="outlined">Oy</td>
                            <td rowSpan="2" className="outlined">Dekada</td>
                            {
                                head1()
                            }
                        </tr>
                        <tr>
                            {
                                head2()
                            }
                        </tr>
                        </thead>

                        {
                            xisobot()
                        }
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Talab;